import React from "react";
import './About.css'
import missionImg from "../images/rocket-icon.png";
import visionImg from "../images/blub-icon.png"
import valuesImg from "../images/360-icon.png";
// Events
// Import images (use your own image paths)
import img1993 from "../images/events/event-1.jpg";
import img1998 from "../images/events/event-2.jpg";
import img2021a from "../images/events/IMG_2540 (1) (1).png";
import img2021b from "../images/events/event-4.png"

import CapacityGraph from "./CapacityGranph";

function AboutUs() {


  return (
    <div>
      {/* Hero Section  */}
      <section className="about">
        {/*  */}
        <section class="container-fluid about-hero py-5">
          <div class="container py-md-5 py-0">
            <div class="row justify-content-center align-items-center py-md-5 py-0">
              <div class="col-lg-3">
                <h1 class="fs-1 text-blue">LEADERSHIP</h1>
              </div>
              <div class="col-lg-7">
                <h3 class="card-title fw-bold text-blue">Mr. Tummala Mohan Reddy</h3>
                <h6 class="card-subtitle mb-3 text-blue">Managing Director</h6>
                <p class="card-text fs-5">
                  A veteran of the manufacturing industry with over five decades of experience, his passion for Engineering, Innovation, and Quality embody the spirit of PREMIER.
                </p>
                {/* <p class="fs-5"><span className="text-blue">Since 1991,</span> PREMIER has been a leading manufacturer of Water Ring Vacuum Pumps, with 25 specialized models offering capacities up to 30,000 m³/h. We provide custom vacuum systems and stock pumps for industries like Thermal Power Plants, Pulp & Paper Mills, and other process applications, delivering tailored solutions worldwide.</p> */}
              </div>
            </div>
          </div>
        </section>

        {/*Membership Cards */}
        <div class="container about-cards">
          <div class="row g-md-5 justify-content-center">
            {/* <!-- Card 1: Mr. T. Mohan Reddy --> */}
            {/* <div class="col-md-4">
              <div class="member-card h-100 shadow-sm p-4 text-center rounded-15">
                <div class="card-body">
                  <h5 class="card-title fw-bold text-blue">Mr. T. Mohan Reddy</h5>
                  <h6 class="card-subtitle mb-3 text-blue">Managing Director</h6>
                  <p class="card-text">
                    A veteran of the manufacturing industry with over five decades of experience, his passion for Engineering, Innovation, and Quality embodies the spirit of PREMIER.
                  </p>
                </div>
              </div>
            </div> */}

            {/* <!-- Card 2: Mr. T. Venkat --> */}
            <div class="col-md-5 mb-md-0 mb-3">
              <div class="member-card h-100 shadow-sm p-4 text-center rounded-15">
                <div class="card-body">
                  <h5 class="card-title fw-bold text-blue">Mr. T. Venkat</h5>
                  <h6 class="card-subtitle mb-3 text-blue">Director</h6>
                  <p class="card-text">
                    A Mechanical Engineer with over two decades of expertise in marketing and customer service, his phenomenal work in sales and insights into product development have led PREMIER to cross new frontiers.
                  </p>
                </div>
              </div>
            </div>

            {/* <!-- Card 3: Mr. V. Avinash --> */}
            <div class="col-md-5 mb-md-0 mb-3">
              <div class="member-card h-100 shadow-sm p-4 text-center rounded-15">
                <div class="card-body">
                  <h5 class="card-title fw-bold text-blue">Mr. V. Avinash</h5>
                  <h6 class="card-subtitle mb-3 text-blue">Director</h6>
                  <p class="card-text">
                    A qualified Lean Manufacturing Engineer with over a decade of experience in the Liquid Ring Vacuum Pump industry, focused on scaling new heights through product innovation and team building, with a belief in growing together.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*Membership Cards */}

        <div className="life-journey">
          <div className="container">
            <h2 className="text-center text-blue fw-bold mb-4">Our Journey</h2>
            {/* <p className="text-center">With 30+ years of expertise, we supply high-performance Liquid Ring Vacuum Pumps to global markets. Our advanced manufacturing facility, skilled workforce, and expert engineering team ensure reliable, superior-quality products for every industrial need.</p> */}
          </div>

          <div className="line-wrapper container position-relative py-4">
            {/* Vertical line */}
            <div className="timeline-vertical-line wow " data-wow-duration="5s"></div>
            <div className="row justify-content-center">
              <div className="col-lg-10 my-3 wow animate__fadeInUp" data-wow-duration="1.5s">
                <div className="row justify-content-cente">
                  <div className="col-5">
                    <img src={img1993} alt="1993" className="img-fluid rounded-3" />
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-center">
                    <div className="text-center bg-white p-2">
                      <div className="d-flex justify-content-center mb-2">
                        <div className="time-dot blinking"></div>
                      </div>
                      <div className="text-blue">
                        <span className="fs-4 fw-bold fs-sm-10">1991</span>
                        <p className="fs-6 fw-bold fs-sm-10">INCEPTION</p>
                        {/* <h3>INCEPTION</h3> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-5 d-flex align-items-center">
                    <p className="fs-sm-10">Began manufacturing of centrifugal process pumps to serve Hyderabad's budding pharmaceutical industry, rapidly positioning ourselves as the market leader.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-10 my-3 wow animate__fadeInUp" data-wow-duration="1.5s">
                <div className="row justify-content-cente">
                  <div className="col-5 d-flex align-items-center">
                    <p className="fs-sm-10">PREMIER began manufacturing it’s flagship product, the Liquid Ring Vacuum Pump, recognizing the growing demand for these pumps in India.
                    </p>
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-center">
                    <div className="text-center bg-white p-2">
                      <div className="d-flex justify-content-center mb-2">
                        <div className="time-dot blinking"></div>
                      </div>
                      <div className="text-blue">
                        <span className="fs-4 fw-bold fs-sm-10">1994</span>
                        <p className="fs-6 fw-bold fs-sm-10">PRODUCT DIVERSIFICATION
                        </p>

                      </div>
                    </div>
                  </div>
                  <div className="col-5">
                    <img src={img1998} alt="1998" className="img-fluid rounded-3" />
                  </div>
                </div>
              </div>
              <div className="col-lg-10 my-3 wow animate__fadeInUp" data-wow-duration="1.5s">
                <div className="row justify-content-cente">
                  <div className="col-5">
                    <img src={img2021a} alt="2021" className="img-fluid rounded-3" />
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-center">
                    <div className="text-center bg-white p-2">
                      <div className="d-flex justify-content-center mb-2">
                        <div className="time-dot blinking"></div>
                      </div>
                      <div className="text-blue">
                        <span className="fs-4 fw-bold fs-sm-10">2011</span>
                        <p className="fs-6 fw-bold fs-sm-10">GOING GLOBAL
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-5 d-flex align-items-center justify-content-center">
                    <p className="fs-sm-10">In pursuit of supplying Liquid Ring Vacuum Pumps in the North and South American regions, PREMIER commenced operations in the U.S.A

                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-10 my-3 wow animate__fadeInUp" data-wow-duration="1.5s">
                <div className="row justify-content-cente">
                  <div className="col-5 d-flex align-items-center justify-content-center">
                    <p className="fs-sm-10">PREMIER intends to revolutionize the Liquid Ring Vacuum Pump market with energy efficient and smart pumps that address the modern challenges of process industries.</p>
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-center">
                    <div className="text-center bg-white p-2">
                      <div className="d-flex justify-content-center mb-2">
                        <div className="time-dot blinking"></div>
                      </div>
                      <div className="text-blue">
                        {/* <span className="fs-4 fw-bold">2021</span> */}
                        <p className="fs-6 fw-bold fs-sm-10">TODAY AND BEYOND
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-5">
                    <img src={img2021b} alt="2021" className="img-fluid rounded-3" />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <section class="container-fluid py-5 mb-5">
          <div class="container">
            <h2 className="text-center fw-bold text-blue mb-5">Our Purpose</h2>
            <div class="row justify-content-center gap-2">
              

              <div class="col-lg-3 ">
                <div class="about-card d-flex align-items-center justify-content-between flex-column gap-4 h-100 px-3">
                  <div class="card-border col-10"></div>
                  <img class="w-px-60  " src={visionImg} alt="" />
                  <div className="p-3 text-center">
                    <h5 class="fw-bold mb-3">
                      Vision Statement
                    </h5>
                    <p class="fs-7">
                      To be the best in what we do.
                    </p>
                  </div>
                  <div class="card-border col-10"></div>
                </div>
              </div>

              <div class="col-lg-3 ">
                <div class="about-card d-flex align-items-center justify-content-between flex-column gap-4 h-100 px-3">
                  <div class="card-border col-10"></div>
                  <img class="w-px-60  " src={missionImg} alt="" />
                  <div className="p-3 text-center">
                    <h5 class="fw-bold mb-3">
                      Mission Statement
                    </h5>
                    <p class="fs-7">
                      Making process industries efficient and profitable by manufacturing pumps that are energy and cost effecient.
                    </p>
                  </div>
                  <div class="card-border col-10"></div>
                </div>
              </div>

              <div class="col-lg-3 ">
                <div class="about-card d-flex align-items-center justify-content-between flex-column gap-4 h-100 px-3">
                  <div class="card-border col-10"></div>
                  <img class="w-px-60  " src={valuesImg} alt="" />
                  <div className="p-3 text-center">
                    <h5 class="mm-3 fw-bold">
                      Core Statement
                    </h5>
                    <p class=" fs-7">
                    Together towards a better tomorrow. 
                    </p>
                  </div>
                  <div class="card-border col-10"></div>
                </div>
              </div>


            </div>

          </div>
        </section>

        {/*  */}
      </section>
      {/* Hero Section  */}
    </div>
  )
}

export default AboutUs